import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MatChip } from "@angular/material/chips";
import { RouterLink } from "@angular/router";

import { PATHS } from "@app/core/constants/path.const";
import {
  EGlobalSearchEntity,
  IGlobalSearch,
} from "@app/shared/response-type/global-search-response.interface";

type TGlobalSearchWithLink = IGlobalSearch & { href: string | null };

const MAP_ENTITY_PATH = new Map<EGlobalSearchEntity, (entityId: string, clientId?: string) => string>([
  [EGlobalSearchEntity.Client, entityId => `${PATHS.clients.path}/${entityId}`],
  [
    EGlobalSearchEntity.Invoice,
    entityId => `${PATHS.billing.path}/${PATHS.billing.invoices.path}/${entityId}`,
  ],
  [
    EGlobalSearchEntity.Policy,
    entityId => `${PATHS.policies.path}/${PATHS.policies.versionDetails.path}/${entityId}`,
  ],
  [
    EGlobalSearchEntity.OperatingCompany,
    (entityId, clientId) =>
      `${PATHS.clients.path}/${clientId}/${PATHS.clients.operationCompany.path}/${entityId}`,
  ],
  [EGlobalSearchEntity.Claim, entityId => `${PATHS.claims.path}/${PATHS.claims.directory.path}/${entityId}`],
  [
    EGlobalSearchEntity.AdditionalInsured,
    (entityId, clientId) =>
      `${PATHS.clients.path}/${clientId}/${PATHS.clients.additionalInsured.path}/${entityId}/${PATHS.clients.additionalInsured.edit.path}`,
  ],
]);

function toLinkItem(item: IGlobalSearch): TGlobalSearchWithLink {
  const segments = MAP_ENTITY_PATH.get(item.entityType);

  if (segments) {
    return { ...item, href: segments(item.entityId, item.clientId) };
  }

  return { ...item, href: null };
}

@Component({
  selector: "under-ui-result-global-search-by-entity",
  templateUrl: "./result-global-search-by-entity.component.html",
  styleUrl: "./result-global-search-by-entity.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatChip, RouterLink],
})
export class ResultGlobalSearchByEntityComponent {
  @Input({ transform: toLinkItem }) item!: TGlobalSearchWithLink;
}
